module.exports = __webpack_public_path__ + "assets/img/tx111t.3559b041.jpg";